import React from 'react'
import {KTIcon} from '@/_metronic/helpers'
import {Sale} from '../../core/_models'
import {useListView} from '@/components/table/core/ListViewProvider'
import {useIntl} from 'react-intl'
import {getTrxStatusColor} from  '../../../_components/colors'
import States from '../../../statement/list/components/States'

export const Overview = () => {
  const intl = useIntl()
  const {itemForUpdate, setItemForUpdate, setAction} = useListView()

  const order = itemForUpdate as Sale
  const status = order.statuses.at(-1)?.status || ''
  const close = () => {
    setAction(undefined)
    setItemForUpdate(undefined)
  }

  return (
    <div>
      <div className='table-responsive'>
        {/* begin::Table */}
        <table className='table align-middle gs-0 gy-5'>
          <tbody>
            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                Order ID
              </td>
              <td className='text-start'>
                <span className='badge badge-light-danger fw-semibold me-1'>
                  {order._id}
                </span>
              </td>
            </tr>

            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                Date
              </td>
              <td className='text-start'>
                <span className='badge badge-light fw-semibold me-1'>
                  {intl.formatDate(order.date, {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                  })}
                </span>
              </td>
            </tr>

            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                Status
              </td>
              <td className='text-start'>
                <span className={`badge badge-light-${getTrxStatusColor(status)} fw-semibold me-1`}>
                  {intl.formatMessage({id: `P2C.ORDER_${status}`})}
                </span>
              </td>
            </tr>


            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                Customer
              </td>
              <td className='text-start'>
                <div className="d-flex align-items-center flex-row-fluid flex-wrap">
                  <div className="flex-grow-1 me-2">
                    <span className="text-gray-800 fs-6 fw-bold">
                      {order.user.username}
                    </span>
                    <span className="text-muted fw-semibold d-block fs-7">
                      {order.user.email}
                    </span>
                  </div>
                </div>
              </td>
            </tr>

            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                Product
              </td>
              <td className='text-start'>
                <div className="d-flex align-items-center flex-row-fluid flex-wrap">
                  <div className="flex-grow-1 me-2">
                    <span className="text-gray-800 fs-6 fw-bold">
                      {order.product}
                    </span>
                    <span className="text-muted fw-semibold d-block fs-7">
                      {order.code}
                    </span>
                  </div>
                </div>

              </td>
            </tr>

            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                Sold price
              </td>
              <td className='text-start'>
                {intl.formatNumber(order.debit, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                })}
                <span className="pe-2 ps-2">/</span>
                {intl.formatNumber(order.debit / order.currencyRate, {
                  style: 'currency',
                  currency: 'EUR',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
                {order.discount && (
                  <span className="badge badge-light-primary">
                    -{order.discount.prc}% {order.discount.code}
                  </span>
                )}
              </td>
            </tr>

            {order.amount !== undefined && (
              <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                <td className='text-start text-gray-700 fw-bold'>
                  Product amount
                </td>
                <td className='text-start'>
                  {intl.formatNumber(order.amount, {
                    style: 'currency',
                    currency: 'EUR',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="pt-15 text-end">
        <button
          type='reset'
          onClick={() => close() }
          className='btn btn-light me-3'
          data-kt-users-modal-action='cancel'
        >
          Close
        </button>
      </div>
    </div>
  )
}

export const OrderOverview = () => {
  const intl = useIntl()
  const {itemForUpdate, setItemForUpdate, setAction} = useListView()

  const order = itemForUpdate as Sale

  if (order === undefined || order === null) {
    return <></>
  }

  const close = () => {
    setAction(undefined)
    setItemForUpdate(undefined)
  }

  return (
    <div>
      <div className='table-responsive'>
        {/* begin::Table */}
        <table className='table align-middle gs-0 gy-5'>
          <tbody>
            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                Order ID
              </td>
              <td className='text-start'>
                <span className='badge badge-light-danger fw-semibold me-1'>
                  {order._id}
                </span>
              </td>
            </tr>

            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                Date
              </td>
              <td className='text-start'>
                <span className='badge badge-light fw-semibold me-1'>
                  {intl.formatDate(order.date, {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                  })}
                </span>
              </td>
            </tr>

            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                States
              </td>
              <td className='text-start'>
                <States states={order.statuses} scope="ORDER"/>
              </td>
            </tr>

            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                Product
              </td>
              <td className='text-start'>
                <div className="d-flex align-items-center flex-row-fluid flex-wrap">
                  <div className="flex-grow-1 me-2">
                    <span className="text-gray-800 fs-6 fw-bold">
                      {order.product}
                    </span>
                    <span className="text-muted fw-semibold d-block fs-7">
                      {order?.code}
                    </span>
                  </div>
                </div>

              </td>
            </tr>

            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              <td className='text-start text-gray-700 fw-bold'>
                Sold price
              </td>
              <td className='text-start'>
                {intl.formatNumber(order.debit || 0, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                })}
                <span className="pe-2 ps-2">/</span>
                {intl.formatNumber((order.debit || 0) / order.currencyRate, {
                  style: 'currency',
                  currency: 'EUR',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
                {order.discount && (
                  <span className="badge badge-light-primary">
                    -{order.discount.prc}% {order.discount.code}
                  </span>
                )}
              </td>
            </tr>

            {order?.amount !== undefined && (
              <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                <td className='text-start text-gray-700 fw-bold'>
                  Product amount
                </td>
                <td className='text-start'>
                  {intl.formatNumber(order.amount, {
                    style: 'currency',
                    currency: 'EUR',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {order?.error && (
          <>
            <div className="d-flex align-items-center collapsed collapsible py-3 toggle mb-0" data-bs-toggle="collapse" data-bs-target="#error">
              <div className="btn btn-sm btn-icon mw-20px btn-active-color-primary me-5">
                <KTIcon iconName='minus-square' className='toggle-on text-danger fs-1' />
                <KTIcon iconName='plus-square' className='toggle-off text-danger fs-1' />
              </div>
              <h4 className="text-danger fw-bold cursor-pointer mb-0">
                Error
              </h4>
            </div>
            <div id="error" className="collapse fs-6 ms-1">
              <div className="mb-4 text-gray-600 fw-semibold fs-6">
                <pre>{JSON.stringify(order.error, null, 2)}</pre>
              </div>
            </div>
          </>
        )}
      </div>

      <div className="pt-15 text-end">
        <button
          type='reset'
          onClick={() => close() }
          className='btn btn-light me-3'
          data-kt-users-modal-action='cancel'
        >
          Close
        </button>
      </div>
    </div>
  )
}

export default OrderOverview
